// import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import ArticleList from "./pages/ArticleList";
import ArticleBody from "./pages/ArticleBody";
import Resources from "./pages/Resources";
import Support from "./pages/Contact";
import About from "./pages/About";
import Privacy from "./pages/legal/Privacy";
import TOS from "./pages/legal/TOS";

function App() {
  return (
    <div className="App dark:bg-background bg-white min-h-screen transition-all duration-300">
      <Router>
        <Routes>
          {/* -------------------------------------------------------------------------- */
          /*                                    Pages                                   */
          /* -------------------------------------------------------------------------- */}

          <Route exact path="/" element={<Home />} />
          <Route exact path="/resources" element={<Resources />} />
          <Route exact path="404" element={<NotFound />} />
          <Route exact path="*" element={<NotFound />} />
          <Route exact path="/contact" element={<Support />} />
          <Route exact path="/about" element={<About />} />

          {/* -------------------------------------------------------------------------- */
          /*                                   Articles                                  */
          /* -------------------------------------------------------------------------- */}

          {/* articles will be routed automatically, no need to add them each time like before. however, you must add them to the article index at src/articles.js */}
          <Route exact path="/articles" element={<ArticleList />} />
          <Route exact path="events" element={<ArticleList />} />
          <Route path="/articles/:eventId" element={<ArticleBody />} />
          <Route path="/events/:eventId" element={<ArticleBody />} />

          {/* -------------------------------------------------------------------------- */
          /*                                     Legal                                   */
          /* -------------------------------------------------------------------------- */}
          <Route exact path="/privacy" element={<Privacy />} />
          <Route exact path="/terms" element={<TOS />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
